export const tags = [
  'adjustments',
  'auth',
  'announcements',
  'announcement',
  'assignments',
  'assignment',
  'accommodations',
  'accommodation-categories',
  'avatar',
  'avatar-parts',
  'academic-periods-select',
  'academic-periods',
  'academic-period',
  'assessments',
  'assess',
  'assignment-attachments',
  'assessment-strategies',
  'assessment-categories',
  'assessment-types',
  'attendance',
  'benchmark-evaluations',
  'benchmark-evaluation-stats',
  'behavior',
  'behaviour',
  'benchmarks',
  'benchmark',
  'birthdays',
  'bookmarks',
  'cluster',
  'clusters',
  'course',
  'courses',
  'course-chapter',
  'course-chapters',
  'course-chapter-materials',
  'course-select',
  'course-chapters-select',
  'course-component',
  'course-components',
  'course-components-select',
  'course-setup-main',
  'course-setup-grading',
  'conversations',
  'concern-reasons',
  'curriculum-map',
  'dashboard-attendance',
  'dashboard-grades',
  'dashboard-students',
  'dashboard-teachers',
  'dashboard-totals',
  'domain',
  'domains',
  'employees',
  'earlyWarnings',
  'final-grades',
  'fluencies',
  'fluency',
  'grades',
  'grade-levels',
  'grade-risk-criteria',
  'grade-scale',
  'grade-scale-item',
  'group-courses',
  'group-course',
  'group-course-select',
  'groups',
  'group',
  'group-course-sessions',
  'group-course-sessions-select',
  'group-course-session',
  'group-course-session-attendance',
  'group-course-session-behaviour-incidents',
  'gradebook-grid',
  'gradebook-grid-assignments',
  'gradebook-grid-student',
  'gradebook-grid-download-report',
  'gradebook-assessments',
  'grade-levels',
  'general-notes',
  'general-note',
  'goal',
  'goals',
  'goal-clusters',
  'goal-complexities',
  'goal-highlights',
  'goal-fluencies',
  'goal-domains',
  'goal-topics',
  'goal-skills',
  'goal-measures',
  'goal-content-areas',
  'goal-progression',
  'highlights',
  'highlight',
  'instructional-strategies',
  'instructional-strategy-categories',
  'intervention-strategies',
  'intervention-strategy-categories',
  'intervention-types',
  'kpi-evaluations',
  'kpi-evaluation-stats',
  'ledger',
  'lesson-plan-options',
  'lesson-plan',
  'lesson-plans',
  'lesson-plans-select',
  'learning-style',
  'meetings',
  'meeting',
  'meeting-categories',
  'meeting-protocol',
  'modifications',
  'modification-categories',
  'my-learning-style',
  'milestones',
  'milestone',
  'medical',
  'medical-record',
  'medical-records',
  'medical-conditions',
  'medical-condition-categories',
  'model-answers',
  'model-answer',
  'monitoring-methods',
  'parents',
  'parent',
  'permissions',
  'practice',
  'practices',
  'private-notes',
  'private-note',
  'peer-assessments',
  'plop-question-categories',
  'plop-categories',
  'plop-report',
  'plop-reports',
  'plop-report-records',
  'plop-report-record',
  'problem-areas',
  'program',
  'progress-monitoring-tools',
  'resources',
  'rubrics',
  'rubric',  
  'rubric-select',
  'roles',
  'risk-criteria',
  'risk-threshold-exceeded-warnings',
  'rti-error-codes',
  'rti-interventions',
  'rti-intervention',
  'rti-risk-criteria-one',
  'rti-risk-criteria-one-list',
  'rti-risk-criteria-one-documents',
  'rti-risk-criteria-two',
  'rti-risk-criteria-two-list',
  'rti-risk-criteria-three',
  'rti-risk-criteria-three-list',
  'search',
  'setup-options',
  'school',
  'slos',
  'slo',
  'skill',
  'skills',
  'staff',
  'staff-member',
  'students',
  'student',
  'student-assignments',
  'student-assignment',
  'student-groups',
  'students-profile-select',
  'student-questions',
  'student-counters',
  'student-answers',
  'student-counters',
  'subjects',
  'submissions',
  'submissions',
  'submission',
  'submission-types',
  'success-criterias',
  'success-criteria',
  'score-types',
  'syllabuses',
  'syllabus',
  'teachers',
  'teacher',
  'teacher-profile-select',
  'timetables',
  'timetable',
  'teams',
  'team',
  'topics',
  'units',
  'users',
  'user',
  'users-select',
  'user-contacts',
  'verbs',
  'verb'
] as const
